export default __webpack_public_path__ + "static/media/bonus1.434a046c.png";